import { render, staticRenderFns } from "./AlGrid.vue?vue&type=template&id=dd8a886a&"
import script from "./AlGrid.vue?vue&type=script&lang=js&"
export * from "./AlGrid.vue?vue&type=script&lang=js&"
import style0 from "./AlGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports